// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1iA-T","errorLogs":"styles_errorLogs__1BWi9"};